// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"c5d32dd9","177":"3d1520cb"}[chunkId] + ".chunk.css";
};